import { render, staticRenderFns } from "./ToDoManagerList.vue?vue&type=template&id=366d2076&"
import script from "./ToDoManagerList.vue?vue&type=script&lang=js&"
export * from "./ToDoManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports